<template>
  <div class="insights-chart-loader">
    <strong class="font-weight-medium">Loading...</strong>
  </div>
</template>

<script>
export default {
  name: 'InsightsChartLoader',
  data () {
    return {

    }
  },
  methods: {

  },
  computed: {

  },
  mounted () {

  }
}
</script>

<style scoped>
  .insights-chart-loader {
    height: 250px;
    display: flex;
    gap: 12px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
</style>
